<template>
  <button
    v-ripple
    :disabled="disabled || loading"
    class="tw-min-h-[40px] tw-relative tw-w-full focus:tw-ring-4 hover:tw-bg-ci-green/90 focus:tw-ring-ci-green focus:tw-outline-none focus:tw-ring-offset-2 focus:tw-ring-opacity-30 lg:tw-w-auto tw-px-5 tw-py-2 tw-text-white tw-bg-ci-green tw-rounded-full disabled:tw-cursor-not-allowed disabled:tw-bg-ci-gray-200 tw-outline-0"
    data-test-buttons-primary-button
    v-bind="$attrs"
    v-on="$listeners">
    <span
      :class="{ 'tw-opacity-0': loading }"
      class="tw-transition-opacity tw-duration-200 tw-leading-snug tw-flex tw-items-center tw-font-semibold">
      <v-icon
        v-if="prependIcon"
        class="-tw-ml-1 tw-mr-3 tw-text-inherit"
        size="22px">
        {{ prependIcon }}
      </v-icon>
      <slot></slot>
      <v-icon
        v-if="appendIcon"
        class="-tw-mr-1 tw-ml-3 tw-text-inherit"
        size="22px">
        {{ appendIcon }}
      </v-icon>
    </span>
    <transition name="fade">
      <span
        v-if="loading"
        class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center">
        <v-icon class="tw-animate-spin tw-text-inherit">mdi-loading</v-icon>
      </span>
    </transition>
  </button>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    prependIcon: {
      type: String,
    },
    appendIcon: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.fade-enter-active {
  transition: transform 0.2s ease-in-out;
}

.fade-enter-from {
  transform: scale(0.8);
}

.fade-enter-to {
  transform: scale(1);
}
</style>
